import {
  ROLE_CONFIG_REQUEST_TYPE_FETCHING,
  ROLE_CONFIG_REQUEST_TYPE_SUCCESS,
  ROLE_CONFIG_REQUEST_TYPE_ADD_SUCCESS,
  ROLE_CONFIG_REQUEST_TYPE_ADD_FAILED,
  ROLE_CONFIG_REQUEST_TYPE_EDIT_SUCCESS,
  ROLE_CONFIG_REQUEST_TYPE_EDIT_FAILED,
  ROLE_CONFIG_REQUEST_TYPE_DELETE_SUCCESS,
  ROLE_CONFIG_REQUEST_TYPE_DELETE_FAILED,
  ROLE_CONFIG_REQUEST_TYPE_FAILED,
  ROLE_CONFIG_REQUEST_TYPE_FIND_BY_ID,
  ROLE_CONFIG_REQUEST_TYPE_CLEAR,
  } from "../services/Constants";
  import { Role_config_request_type } from "../types/role_config_request_type.type";
    
    export interface role_config_request_typeState {
        result: Role_config_request_type[];
        isFetching: boolean;
        isError: boolean;
        isAdddata: boolean,
        isEditdata: boolean,
        isAddError: boolean;
        isEditError: boolean;
        isDeletedata: boolean;
        isDeleteError: boolean;
        result_by_id: any;
    }
    
    const initialState: role_config_request_typeState = {
        result: [],
        isFetching: false,
        isError: false,
        isAdddata: false,
        isEditdata: false,
        isAddError: false,
        isEditError: false,
        isDeletedata: false,
        isDeleteError: false,
        result_by_id: null,
    };
    
    export default (state = initialState, { type, payload}: any) => {
      switch (type) {
        case ROLE_CONFIG_REQUEST_TYPE_FETCHING:
          return { ...state, result: [], result_by_id: null, isFetching: true,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: false};
        case ROLE_CONFIG_REQUEST_TYPE_SUCCESS:
          return { 
            ...state, 
            result: payload,
            result_by_id: null,
            isFetching: false,
            isAdddata: false,
            isEditdata: false,
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
          case ROLE_CONFIG_REQUEST_TYPE_ADD_SUCCESS:
          return { 
            ...state, 
            result_by_id: null,
            isFetching: false,
            isAdddata: true,
            isEditdata: false, 
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
          case ROLE_CONFIG_REQUEST_TYPE_EDIT_SUCCESS:
          return { 
            ...state, 
            result_by_id: null,
            isFetching: false, 
            isAdddata: false,
            isEditdata: true, 
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
        case ROLE_CONFIG_REQUEST_TYPE_FAILED:
          return { ...state, result: [],result_by_id: null, isFetching: false,isAdddata: false,isEditdata: false,
             isError: true,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: false};
        case ROLE_CONFIG_REQUEST_TYPE_ADD_FAILED:
          return { ...state, result: [],result_by_id: null, isFetching: false,isAdddata: false,isEditdata: false,
             isError: false,isAddError: true,isEditError: false,isDeletedata: false,isDeleteError: false};
          case ROLE_CONFIG_REQUEST_TYPE_EDIT_FAILED:
          return { ...state, result: [],result_by_id: null, isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: true,isDeletedata: false,isDeleteError: false};
            case ROLE_CONFIG_REQUEST_TYPE_DELETE_SUCCESS:
          return { ...state, result: [],result_by_id: null, isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: true,isDeleteError: false};
            case ROLE_CONFIG_REQUEST_TYPE_DELETE_FAILED:
          return { ...state, result: [],result_by_id: null, isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: true};
            case ROLE_CONFIG_REQUEST_TYPE_FIND_BY_ID:
          return { ...state, result_by_id: payload };

        default:
          return state;
      }
      
    };
    